import { FontConfig } from "../types"

export const BODY_6XL_CONFIG: FontConfig = {
  title: "BODY/6xl",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 30, tw: "text-[30px]" },
    lineHeight: { px: 46, tw: "leading-[46px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 38, tw: "text-[38px]" },
    lineHeight: { px: 56, tw: "leading-[56px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 48, tw: "text-[48px]" },
    lineHeight: { px: 69, tw: "leading-[69px]" },
  },
}
